import { render, staticRenderFns } from "./LocalEventCell.vue?vue&type=template&id=ea0b53a4"
import script from "./LocalEventCell.vue?vue&type=script&lang=js"
export * from "./LocalEventCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports